import { create } from 'zustand';
import { ProviderAwareUserSummary } from '@/types/providerUser';

export interface PerformanceReview {
  uuid: string;
  org_uuid: string;
  team_uuid?: string;
  content: string;
  start_date: string;
  end_date: string;
  date_generated: string;
  average_bug_ratio?: number;
  average_merge_frequency?: number;
  average_overall_score?: number;
  average_story_points?: number;
  average_pr_size?: number;
  team_name?: string;
  user_uuid: string;
  user: ProviderAwareUserSummary;
}

interface PerformanceReviewState {
  reviews: PerformanceReview[];
  currentReview: PerformanceReview | null;
  setReviews: (reviews: PerformanceReview[]) => void;
  setCurrentReview: (review: PerformanceReview) => void;
}

export const usePerformanceReviewState = create<PerformanceReviewState>(
  (set) => ({
    reviews: [],
    currentReview: null,
    setReviews: (reviews) => set({ reviews }),
    setCurrentReview: (review) => set({ currentReview: review }),
  })
);
